import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'

import Login from '@@/views/common/login'
import Regist from '@@/views/common/regist'
import ErrorPage from '@@/views/common/errorPage'

import Home from '@@/views/home'
import Notice from '@@/views/notice/notice'
import Record from '@@/views/record/record'
import User from '@@/views/user/user'

import Info from '@@/views/items/info'
import PersonalInfo from '@@/views/items/info/personalInfo'
import ParentsInfo from '@@/views/items/info/parentsInfo'
import ParentsInfoEdit from '@@/views/items/info/parentsInfoEdit'

import Car from '@@/views/items/car'
import CarInfo from '@@/views/items/car/carInfo'

import Address from '@@/views/items/address'

import Loan from '@@/views/items/loan'

import Dormroom from '@@/views/items/dormroom'
import DormroomDeatil from '@@/views/items/dormroom/dormroomDeatil'
import DormChoseRoom from '@@/views/items/dormroom/dormChoseRoom'

import Pay from '@@/views/items/pay'
import PendingBill from '@@/views/items/pay/pendingBill'

import Picture from '@@/views/items/picture'

import Clothes from '@@/views/items/clothes'
import ClotheSize from '@@/views/items/clothes/clotheSize'

import Medical from '@@/views/items/medical'
import MedicalDate from '@@/views/items/medical/medicalDate'
import MedicalResult from '@@/views/items/medical/medicalResult'

import Books from '@@/views/items/books'
import Alumnus from '@@/views/items/alumnus'

import ItemResult from '@@/views/items/itemResult'

import Default from '@@/views/items/default'

import MessageList from '@@/views/notice/messageList'
import NoticeDetail from '@@/views/notice/noticeDetail'

import MapPosition from '@@/views/record/map'

import UserInfo from '@@/views/user/userItem/userinfo'
import Qrcode from '@@/views/user/userItem/myQrcode'
import FullOffer from '@@/views/user/userItem/fullOffer'
import FindClassmate from '@@/views/user/userItem/findClassmate'
import FindClassmateDetail from '@@/views/user/userItem/findClassmate/findClassmateDetail'
import Donate from '@@/views/user/userItem/donate'
// import DonateResult from '@@/views/user/userItem/donateResult'
import Privacy from '@@/views/user/userItem/privacy'
import Password from '@@/views/user/userItem/password'
Vue.use(Router)
const routes = [
  {
    path: '/',
    redirect: () => {
      var wx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
      // alert(navigator.userAgent.toLowerCase())
      if (wx) {
        return '/login'
      } else {
        return '/home'
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录',
      tabbar: false
    }
  },
  {
    path: '/regist',
    name: 'regist',
    component: Regist,
    meta: {
      title: '注册',
      tabbar: false
    }
  },
  {
    path: '/errorPage',
    name: 'errorPage',
    component: ErrorPage,
    meta: {
      title: '错误提示',
      tabbar: false
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: '迎新注册离校',
      tabbar: true,
      requireAuth: false
    }
  },
  {
    path: '/record',
    name: 'record',
    component: Record,
    meta: {
      title: '办理记录',
      tabbar: true,
      requireAuth: true
    },
    children: [
      {
        path: 'mapPosition/:flowProcedureId/:procedureId/:title',
        name: 'mapPosition',
        component: MapPosition,
        meta: {
          title: '个人信息',
          tabbar: false
        }
      }
    ]
  },
  {
    path: '/notice',
    name: 'notice',
    component: Notice,
    meta: {
      title: '通知',
      tabbar: true
    },
    children: [
      {
        path: '/messageList',
        name: 'messageList',
        component: MessageList,
        meta: {
          title: '私信',
          tabbar: false
        }
      },
      {
        path: 'noticeDetail',
        name: 'noticeDetail',
        component: NoticeDetail,
        meta: {
          title: '通知详情',
          tabbar: false
        }
      }
    ]
  },
  {
    path: '/user',
    name: 'user',
    component: User,
    meta: {
      title: '我的',
      tabbar: true
    },
    children: [
      {
        path: 'usserInfo',
        name: 'userInfo',
        component: UserInfo,
        meta: {
          title: '个人信息',
          tabbar: false,
          requireAuth: true
        }
      },
      {
        path: 'qrcode',
        name: 'qrcode',
        component: Qrcode,
        meta: {
          title: '我的二维码',
          tabbar: false,
          requireAuth: true
        }
      },
      {
        path: 'fullOffer',
        name: 'fullOffer',
        component: FullOffer,
        meta: {
          title: '录取通知书',
          tabbar: false,
          requireAuth: true
        }
      },
      {
        path: 'donate',
        name: 'donate',
        component: Donate,
        meta: {
          title: '余额捐赠',
          tabbar: false,
          requireAuth: true
        }
      },
      {
        path: 'findClassmate',
        name: 'findClassmate',
        component: FindClassmate,
        meta: {
          title: '找同学',
          tabbar: false,
          requireAuth: true
        },
        children: [
          {
            path: 'findClassmateDetail',
            name: 'findClassmateDetail',
            component: FindClassmateDetail,
            meta: {
              title: '找同学',
              tabbar: false
            }
          }
        ]
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: Privacy,
        meta: {
          title: '隐私设置',
          tabbar: false,
          requireAuth: true
        }
      },
      {
        path: 'password',
        name: 'password',
        component: Password,
        meta: {
          title: '修改密码',
          tabbar: false,
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/info',
    name: 'info',
    component: Info,
    meta: {
      title: '完善信息',
      tabbar: false,
      requireAuth: true
    },
    children: [
      {
        path: 'personalInfo',
        name: 'personalInfo',
        component: PersonalInfo,
        meta: {
          title: '个人信息',
          tabbar: false
        }
      },
      {
        path: 'parentsInfo',
        name: 'parentsInfo',
        component: ParentsInfo,
        meta: {
          title: '家庭成员信息',
          tabbar: false
        },
        children: [
          {
            path: 'parentsInfoEdit',
            name: 'parentsInfoEdit',
            component: ParentsInfoEdit,
            meta: {
              title: '填写家庭成员信息',
              tabbar: false
            }
          }
        ]
      }
    ]
  },
  {
    path: '/car',
    name: 'car',
    component: Car,
    meta: {
      title: '接站预订',
      tabbar: false,
      requireAuth: true
    },
    children: [
      {
        path: '/carInfo/:type',
        name: 'carInfo',
        component: CarInfo,
        meta: {
          title: '接站预订',
          tabbar: false
        }
      }
    ]
  },
  {
    path: '/loan',
    name: 'loan',
    component: Loan,
    meta: {
      title: '绿色通道',
      tabbar: false,
      requireAuth: true
    }
  },
  {
    path: '/dormroom',
    name: 'dormroom',
    component: Dormroom,
    meta: {
      title: '宿舍选择',
      tabbar: false,
      requireAuth: false
    },
    children: [
      {
        path: 'dormroomDeatil',
        name: 'dormroomDeatil',
        component: DormroomDeatil,
        meta: {
          title: '宿舍选择',
          tabbar: false
        }
      },
      {
        path: 'dormChoseRoom',
        name: 'dormChoseRoom',
        component: DormChoseRoom,
        meta: {
          title: '预约床位',
          tabbar: false
        }
      }
    ]
  },
  {
    path: '/pay',
    name: 'pay',
    component: Pay,
    meta: {
      title: '缴费明细',
      tabbar: false,
      requireAuth: true
    },
    children: [
      {
        path: 'pendingBill',
        name: 'pendingBill',
        component: PendingBill,
        meta: {
          title: '待缴账单',
          tabbar: false
        }
      }
    ]
  },
  {
    path: '/picture',
    name: 'picture',
    component: Picture,
    meta: {
      title: '上传图片',
      tabbar: false,
      requireAuth: true
    }
  },
  {
    path: '/address',
    name: 'address',
    component: Address,
    meta: {
      title: '户口迁移',
      tabbar: false,
      requireAuth: true
    }
  },
  {
    path: '/clothes',
    name: 'clothes',
    component: Clothes,
    meta: {
      title: '军训服装',
      tabbar: false,
      requireAuth: true
    },
    children: [
      {
        path: 'clotheSize',
        name: 'clotheSize',
        component: ClotheSize,
        meta: {
          title: '尺码设置',
          tabbar: false
        }
      }
    ]
  },
  {
    path: '/medical',
    name: 'medical',
    component: Medical,
    meta: {
      title: '体检预约',
      tabbar: false,
      requireAuth: true
    },
    children: [
      {
        path: '/medicalDate',
        name: 'medicalDate',
        component: MedicalDate,
        meta: {
          title: '体检预约',
          tabbar: false
        }
      },
      {
        path: '/medicalResult',
        name: 'medicalResult',
        component: MedicalResult,
        meta: {
          title: '体检预约',
          tabbar: false
        }
      }
    ]
  },
  {
    path: '/books',
    name: 'books',
    component: Books,
    meta: {
      title: '教材预订',
      tabbar: false,
      requireAuth: true
    }
  },
  {
    path: '/default',
    name: 'default',
    component: Default,
    meta: {
      title: '',
      tabbar: false,
      requireAuth: true
    }
  },
  {
    path: '/alumnus/:isEdit',
    name: 'alumnus',
    component: Alumnus,
    meta: {
      title: '校友部信息填写',
      tabbar: false,
      requireAuth: true
    }
  },
  {
    path: '/itemResult/',
    name: 'itemResult',
    component: ItemResult,
    meta: {
      title: '结果',
      tabbar: false
    }
  }
]

const router = new Router({
  routes
})
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    let token = store.state.token
    var wx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    if (wx) {
      if (to.matched.some(record => record.meta.requireAuth) && (token === null || token === '')) {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/router/index.js